import { css } from 'styled-components'

export type ClipBoardStyleProps = {
	height?: string
	hideBorder?: boolean
}
export const clipBoardStyles = css<ClipBoardStyleProps>`
	position: relative;

	.copy-success {
		overflow: hidden;
		position: absolute;
		z-index: 10;
		top: 0;
		left: 0;
		width: 100%;
		pointer-events: none;

		.slide-drawer {
			width: 100%;
			transition: transform ${props => props.theme.times.tranS};
			background: ${props => props.theme.colors.midNeutral.val};
			color: ${props => props.theme.colors.white.val};
			padding: 0.5em 1em;
			text-align: center;
		}
	}

	.copy-preview {
		padding: 1em;
		border: solid 1px ${props => props.theme.colors.midNeutral.light().val};
		${p =>
			p.hideBorder
				? css`
						border: none;
				  `
				: ''}
		border-bottom: none;
		max-height: ${p => p.height || '100px'};
		overflow-y: auto;
	}
	.copy-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0.8em 2em;
		width: 100%;
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
		border: solid 1px;
		color: ${props => props.theme.colors.midNeutral.val};
		text-transform: uppercase;

		&:hover {
			color: ${props => props.theme.colors.secondary.val};
		}

		.icon {
			padding-right: 0.5em;
			height: 20px;
			width: 20px;
		}
	}

	&.__icon-only {
		.copy-preview {
			border-bottom: solid 1px ${props => props.theme.colors.midNeutral.light().val};
			max-height: initial;

			${p =>
				p.hideBorder
					? css`
							border: none;
					  `
					: ''}
		}
		.copy-btn {
			position: absolute;
			bottom: 0;
			right: 0;
			z-index: 5;
			padding: 0.5em;
			color: ${props => props.theme.colors.white.val};
			background: ${props => props.theme.colors.midNeutral.val};
			opacity: 0.5;
			border-radius: 0;
			border-top-left-radius: 15px;
			transition: opacity ${props => props.theme.times.tranS};
			width: auto;
			&:hover {
				opacity: 1;
			}
		}
	}

	&.__no-preview {
		.copy-success {
			transform: translateX(-100%);
			width: 100px;
			font-size: 0.7rem;
			height: 100%;

			/* fixes a slight offset for some reason */
			top: 1px;
			left: 1px;

			.slide-drawer {
				padding: 2px;
				max-height: 100%;
				background: ${props => props.theme.colors.midNeutral.light().val};
			}
		}

		&.__icon-only {
			.copy-btn {
				position: relative;
				opacity: 1;
				border-radius: 0;
				&:hover {
					background: ${props => props.theme.colors.secondary.val};
				}
				.icon {
					padding: 0;
				}
			}
		}
	}
`
